module.exports = __webpack_public_path__ + "img/onxon.com-laodl-800x800.a9975cc3.jpg";